import axiosConfig from "../../common/config/axiosConfig";
import {
    OfferCartRequest,
    OfferCartResponseError,
    OfferCartResponseNeedConfirmation,
    OfferCartResponseSuccess
} from "../models/CartApiResponse";
import {AxiosError} from "axios";
import {SponsorCartRequest, SponsorCartResponse, SponsorCartResponseSuccess} from "../models/SponsorCartResponse";

export class CartService {
    private static readonly API_URLS = {
        CART: '/api/cart',
        ADD_SPONSOR: '/api/cart/sponsor',
    };

    static setCart(payload: OfferCartRequest, shouldRedirectOnError: boolean = true): Promise<OfferCartResponseSuccess> {
        return new Promise((resolve, reject) => {
            axiosConfig.post(this.API_URLS.CART, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'token': document.body.dataset.token || ''
                },
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                this.handleApiError(error, reject, shouldRedirectOnError);
            });
        });
    }

    static addSponsor(payload: SponsorCartRequest): Promise<SponsorCartResponse> {
        return new Promise((resolve) => {
            axiosConfig.post(this.API_URLS.ADD_SPONSOR, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'token': document.body.dataset.token || ''
                },
            }).then(() => {
                resolve({ type: "success", redirectUrl: "" });
            }).catch(error => {
                resolve(this.handleSponsorApiError(error));
            });
        });
    }

    private static handleApiError(
        error: AxiosError,
        reject: (reason?: any) => void,
        shouldRedirectOnError: boolean = true
    ): void {
        const response = error.response;
        if (!response) {
            reject({status: 500});
            return;
        }

        const needConfirmationError = (response.data as OfferCartResponseNeedConfirmation) || null;
        const errorData = (response.data as OfferCartResponseError) || null;

        if (needConfirmationError?.parameters) {
            reject({
                type: 'needConfirmation',
                parameters: needConfirmationError.parameters,
                message: needConfirmationError.message || null
            });
        } else if (errorData?.redirectUrl) {
            if (shouldRedirectOnError) {
                window.location.href = errorData.redirectUrl;
            }
            reject({
                status: response.status,
                redirectUrl: errorData.redirectUrl,
                redirecting: shouldRedirectOnError,
            });
        } else {
            reject({
                status: response.status
            });
        }
    }

    private static handleSponsorApiError(error: AxiosError): SponsorCartResponse {
        const statusCode = error.response?.status;
        if (statusCode === 404) {
            return { type: "notFound" };
        } else if (statusCode === 400) {
            return { type: "badRequest"}
        } else {
            return { type: "error"}
        }
    }
}
